export default __webpack_public_path__ + "static/media/benefits-assurance.fc5b8039.jpg";